import { Box, Typography } from "@mui/material";

type StatusBarCardBinExcelUploadListProps = {
  operation: 'ADD' | "UPDATE" | "DELETE" | string;
  isValid: boolean;
};

export const StatusBarCardBinExcelUploadList = ({ operation, isValid }: StatusBarCardBinExcelUploadListProps) => {

  let bgColor;
  let borderColor;
  let textColor;
  let text;

  if (isValid) {
    switch (operation) {
      case 'ADD':
        bgColor = "success.extraLighter";
        borderColor = "#00B0A6";
        textColor = "success.main";
        text = 'EKLENECEK';
        break;

      case 'DELETE':
        bgColor = "error.extraLighter";
        borderColor = "#ff0000";
        textColor = "error.main";
        text = 'SILINECEK';
        break;

      default:
        bgColor = "warning.extraLighter";
        borderColor = "#ffb800";
        textColor = "warning.main";
        text = 'GÜNCELLENECEK';
        break;
    }
  } else {
    bgColor = "#f5f5f5";
    borderColor = "#616161";
    textColor = "#616161";
    text = 'GEÇERSİZ';
  }



  return (<Box sx={{ textAlign: 'center', width: 150, borderRadius: 2, backgroundColor: bgColor, border: `1px solid ${borderColor}` }}>
    <Typography variant="overline" color={textColor}>{text}</Typography>
  </Box>);
}